import { fetchPayments, payHost } from '@/services/payment/paymentService'
const state = {
    payments: [],
}

const getters = {
    payments: (state) => state.payments,
}

const actions = {

  async fetchPayments({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)
    const defaultParams = {
      activesOnly: false,
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }
    const params = { ...defaultParams, ...rootState.filters.filters }
    try {
      const { data } = await fetchPayments(params)
      const { result, total } = await data
      commit('setPayments', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async callPayHost({}, requestBody) {
    return payHost(requestBody);
  }
}

const mutations = {
    setPayments: (state, payments) => {
        state.payments = payments
    },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
